module.exports = __webpack_public_path__ + "media/images/png/rent/6-a685559ad0a47279243e07a122dad1c5.png";